import { render } from "./404.vue?vue&type=template&id=408aaac5&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=408aaac5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408aaac5"]])

export default __exports__